// 通用模块
import {
  IBusinessListItem,
  ICountryListItem,
  IBannerListItem,
  IHomeTrainerTeamItem,
  IHomeUserComment,
  InvitationCourseDetail,
  News,
  IDictItem,
  UserClassroomItem,
  IHomeCourseItem,
  IProvinceListItem,
  HomeDialogFormItem
} from '@/interface'
import {
  getBusinessTypeList,
  getCountryList,
  getAboutUsInfo,
  getBannerInfo,
  getTrainerInfoList,
  getHomeImages,
  getTopNewsList
} from '@/request/api/common'
import { Commit } from 'vuex'

const COUNTRY_TYPE = {
  country: 0,
  region: 1
}

export interface FAQItem {
  title: string
  content: string
  fold?: boolean
}

const state = {
  countryList: [] as ICountryListItem[],
  provinceList: [] as IProvinceListItem[],
  businessTypeList: [] as IBusinessListItem[],
  bannerList: {} as Record<string, IBannerListItem[]>,
  trainerTeams: [] as IHomeTrainerTeamItem[],
  userComment: [] as IHomeUserComment[],
  homeImages: [] as IDictItem[],
  regionImages: [] as IDictItem[],
  COUNTRY_TYPE,
  faqList: [] as FAQItem[],
  invitationCourseDetail: {} as InvitationCourseDetail,
  topNewsList: [] as News[],
  formItemobject: {} as HomeDialogFormItem,
  homeCourseList: [] as IHomeCourseItem[],
  homeClassroomList: [] as UserClassroomItem[],
  hppLoginCheckStatus: '0'
}

export type CommonState = typeof state

const commonStore = {
  namespaced: true,
  state,
  actions: {
    async getCountryList ({ commit, state }: { commit: Commit, state: CommonState }, payload?: { type?: number, countryQueryType?: number }) {
      const type = payload?.type || COUNTRY_TYPE.country
      const res = await getCountryList({ type, countryQueryType: payload?.countryQueryType })
      commit('setCountryList', res.data || [])
    },

    async getBusinessTypeList ({ commit }: { commit: Commit }) {
      const res = await getBusinessTypeList()
      commit('setBusinessTypeList', res.data || [])
    },
    async initHomePageInfo ({ commit }: { commit: Commit }) {
      const res = await Promise.all([
        getBannerInfo({ typeList: ['0'] }),
        getAboutUsInfo(),
        getTrainerInfoList(),
        getHomeImages(),
        getHomeImages('region_map'),
        getTopNewsList()
      ])
      commit('setHomeBannerInfo', res?.[0]?.data || [])
      commit('setUserCommentList', res?.[1]?.data || [])
      commit('setHomeTrainerTeam', res?.[2]?.data || [])
      commit('setHomeImages', res?.[3]?.data || [])
      commit('setRegionMap', res?.[4]?.data || [])
      commit('setTopNewsList', res?.[5]?.data || [])
    }
  },
  mutations: {
    setCountryList (state: CommonState, list: ICountryListItem[]): void {
      state.countryList = list
    },
    setBusinessTypeList (state: CommonState, list: IBusinessListItem[]): void {
      state.businessTypeList = list
    },
    setHomeBannerInfo (state: CommonState, list: IBannerListItem[]): void {
      // 设置首页banner
      state.bannerList.home = list
    },
    setHomeTrainerTeam (state: CommonState, list: IHomeTrainerTeamItem[]): void {
      // 设置首页教师团队
      state.trainerTeams = list
    },
    setUserCommentList (state: CommonState, list: IHomeUserComment[]): void {
      // 设置首页用户评论
      state.userComment = list
    },
    setHomeImages (state: CommonState, list: IDictItem[]): void {
      // 设置首页skill build 图片
      state.homeImages = list
    },
    setForSupplementObject (state: CommonState, item: HomeDialogFormItem): void {
      // 设置首页dialog页面form表单显示字段
      state.formItemobject = item
    },
    setRegionMap (state: CommonState, list: IDictItem[]): void {
      // 设置首页区域地图
      state.regionImages = list
    },
    setFAQList (state: CommonState, list: FAQItem[]): void {
      // 设置首页区域地图
      state.faqList = (list || []).map((i, index) => ({
        ...i,
        fold: index !== 0
      }))
    },
    setInvitationCourseDetail (state: CommonState, detail: InvitationCourseDetail): void {
      state.invitationCourseDetail = detail
    },
    setTopNewsList (state: CommonState, news: News[]): void {
      state.topNewsList = news
    },
    seCourseList (state: CommonState, list: IHomeCourseItem[]): void {
      state.homeCourseList = list
    },
    setClassroomList (state: CommonState, list: UserClassroomItem[]): void {
      state.homeClassroomList = list
    },
    setHppLoginCheckStatus (state: CommonState, status: string): void {
      state.hppLoginCheckStatus = status
    }
  }
}

export {
  commonStore
}
